import './index.scss';

(function ($) {
  'use strict';

  const sendEmail = $button => {
    $button.prop('disabled', true).text('Enviando...');

    Thor.User.send_email_confirmation({ user_id: currentUser.id }, {})
      .then(() => {
        $button.parent().html($button.data('already-sent'));
      })
      .catch(() => {
        $button.prop('disabled', false).text('Enviar link de confirmação');

        $button
          .parent()
          .append(
            '<p class="text-danger mt-2">Erro ao enviar o e-mail. Tente novamente.</p>'
          );
      });
  };

  $(document).on('click', '.js-btn-resend-email', event => {
    event.preventDefault();
    event.stopPropagation();
    const $button = $(event.currentTarget);

    sendEmail($button);
  });
})(jQuery);
